import PageCard from "features/shared/components/card/PageCard";
import FormGroup from "features/shared/forms/components/FormGroup";
import { UseFormHookResult } from "features/shared/forms/hooks/useForm";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";

type Props = {
  formHandler: UseFormHookResult;
};

const OtherInfoSubForm = ({ formHandler }: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix(
    "contracting\\contracting",
    "otherInfoSubForm"
  );

  // form hook props
  const { bindFieldNew, errors } = { ...formHandler };

  // render
  return (
    <>
      <h4 className="text-muted mb-3">{tLabels("title")}</h4>
      <PageCard
        title={tLabels("cardTitle")}
        bodyClassName="pt-4 px-4"
        cardClassName="mb-4"
      >
        <div className="row no-gutters mx-n2">
          <div className="col-md-6 px-2">
            <FormGroup
              labelText={tLabels("referralCustomerCode.label")}
              inputId="referralCustomerCode"
              validationError={errors["referralCustomerCode"]}
              tooltip={{
                id: "referralCustomerCodeTooltip",
                trigger: "click",
                placement: "top",
                content: tLabels("referralCustomerCode.tooltip")
              }}
            >
              <input
                id="referralCustomerCode"
                className="form-control"
                placeholder={tLabels("referralCustomerCode.placeholder")}
                {...bindFieldNew("referralCustomerCode", true)}
              />
            </FormGroup>
          </div>
        </div>
      </PageCard>
    </>
  );
};

export default OtherInfoSubForm;
